import { useAuthStore } from '../store/authStore';
import { roleConfigurations } from '../config/roleConfig';
import { Module, ModulePermission } from '../types/roles';

export const usePermissions = () => {
  const { user } = useAuthStore();

  const hasPermission = (module: Module, requiredPermission: ModulePermission): boolean => {
    if (!user) return false;

    const roleConfig = roleConfigurations[user.role];
    if (!roleConfig) return false;

    const userPermission = roleConfig.permissions[module];

    switch (userPermission) {
      case 'full':
        return true;
      case 'write':
        return requiredPermission !== 'full';
      case 'read':
        return requiredPermission === 'read';
      default:
        return false;
    }
  };

  const canManageDepartment = (departmentId: string): boolean => {
    if (!user) return false;
    
    // Super admin, admin, owner, and HR manager can manage all departments
    if (user.email === 'cybersnow@imatics.com' || 
        ['admin', 'owner', 'hr_manager'].includes(user.role)) {
      return true;
    }

    // Department heads can manage their own department
    return user.department_id === departmentId && 
           ['project_manager', 'design_manager', 'production_manager', 
            'inventory_manager', 'sales_team'].includes(user.role);
  };

  return {
    hasPermission,
    canManageDepartment,
    userRole: user?.role
  };
};